export default {
  voluntary_transfer: 'Transferência voluntária',
  forced_transfer: 'Transferência forçada',
  company_sale: 'Venda da empresa',
  termination: 'Desligamento do owner anterior',
  death: 'Falecimento',
  security_recovery: 'Recuperação de segurança',
  judicial_order: 'Ordem judicial',
  platform_override: 'Intervenção formal da plataforma'
};